<template>

    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange">
        <Clearning :navsub="11" :options="c_myoption" v-if="isload"></Clearning>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'learning',
        mixins: [mixinmember],
        components: {
            Clearning: () => import('@/components/Clearning')
        },
        data() {
            return {
                curnavkv: 26
            };
        },
        computed: {

            c_options: function () {
                let _options = { 'hasoption': true, 'courselev': 4, 'showcourse': 4, 'haskw': true, 'anycourse': true, 'hasgroup': 1, 'showschool': true, 'showgroup': true };
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            }
        }

    }
</script>
